import styled from 'styled-components';

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 10px;
	align-items: center;
`;

export const InputsWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	margin-bottom: 12px;
`;
